var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip",on:{"mouseenter":_vm.enter,"mouseleave":_vm.leave}},[_c('div',{staticClass:"tooltip-bulle",class:'pos-'+_vm.position,style:(_vm.style)},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }